<template>
  <fragment>
    <b-modal
      :id="`modal-select-template-website`"
      modal-class="modal-select-template-website"
      size="xl"
      no-close-on-esc 
      no-close-on-backdrop
      hide-footer
      @shown="init()"
    >
      <template #modal-header>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <div class="modal-title">
              <span class="backIcon cursor-pointer mr-10" @click="close()">
                <i class="fal fa-arrow-left fs-16"></i>
              </span>
              <TitleModal 
                :label="$t('engine.manageAppearance.theme.template.lblTitleModal', languageEngine)" 
              />
            </div>
            <div
              id="close-modal-select-template-page"
              type="button"
              class="close-modal"
              aria-label="Close"
              @click="close"
            >
              <i class="fal fa-times"></i>
            </div>
          </div>
        </div>
      </template>
    
      <div class="wrapper">
        <!-- <div class="template-categories" >
          <div class="cate-wrapper" :class="{'selected': menuSelected == 0}" v-b-toggle="'collapse-hide'" @click="selectCategory(0); menuActive(0);">
            <span class="fs-db-20">All</span>
          </div>
          <div class="cate-wrapper" :class="{'selected': menuSelected == 'free'}"  v-b-toggle="'collapse-hide'" @click="selectCategory('free'); menuActive('free');">
            <span class="fs-db-20">Free</span>
          </div>
          <div class="cate-wrapper" :class="{'selected': menuSelected == key}" v-for="(key, index) in Object.keys(displayCategory)" :key="`cate-${index}`" v-b-toggle="`cate-collapse-${key}`" @click="menuActive(key)">
            <span class="fs-db-20">{{ $t(`engine.manageAppearance.theme.template.lblCategory_${key}`, languageEngine) }}</span>
          </div>
        </div> -->
        <div class="cate-collapse-wrapper" >
          <b-collapse class="d-none" :id="'collapse-hide'" accordion="my-accordion">
          </b-collapse>
          <b-collapse v-for="(key, index) in  Object.keys(displayCategory)" :key="`cate-collapse-${index}`" :id="`cate-collapse-${key}`" accordion="my-accordion">
            <div class="cate-collapse" :class="{'selected': categoryFilter == child.WebsiteCategoryID}" v-for="(child, k) in displayCategory[key]" :key="`child-cate-${k}`" @click="selectCategory(child.WebsiteCategoryID)">
              {{ child.WebsiteCategoryName }}
            </div>
          </b-collapse>
        </div>
        <b-overlay
          id="overlay-background"
          :show="fetching"
          :class="{ show: fetching }"
          variant="light"
          :opacity="0.85"
          rounded="sm" 
          v-if="fetching"
        />
        <div class="list" style="position: relative;" v-else>
            <div class="selected thumbnail-wrapper" v-if="template && options.p == 1">
              <div class="template-img-wrapper" style="text-align: center;" v-if="template && template.templateImage">
                <div class="selected-icon" >
                  <img :src="require('@assets/images/image_template/selected_check_icon.png')"/>
                </div>
                <img :src="template.templateImage" style="width: 100%; object-fit: fill;" />
              </div>
              <div class="detail-wrapper" style="display: flex; justify-content: space-between; padding-top: 24px;">
                <div>{{ template.templateName }}</div>
                <div class="btn-wrapper">
                  <button class="btn fs-db-20 fw-400 btn-default btn-md" @click="openPreview(template)"><i class="fal fa-search"></i> Preview</button>
                  <!-- <button class="btn px-gd-2 ml-gd-1 fs-db-20 fw-400 btn-blue btn-md" @click="selectToConfirm(template)">Select</button> -->
                </div>
              </div>
            </div>
            <template v-for="(temp, index) in templateList">
              <div class="thumbnail-wrapper" :key="`template-${index}`">
                <div class="template-img-wrapper" style="text-align: center;">
                  <img :src="temp.templateImage" style="width: 100%; object-fit: fill;" />
                </div>
                <div class="detail-wrapper" style="display: flex; justify-content: space-between; padding-top: 24px;">
                  <div>{{ temp.templateName }}</div>
                  <div class="btn-wrapper">
                    <button class="btn fs-db-20 fw-400 btn-default btn-md" @click="openPreview(temp)"><i class="fal fa-search"></i> Preview</button>
                    <button class="btn px-gd-2 ml-gd-1 fs-db-20 fw-400 btn-blue btn-md" v-if="temp.isAvaliabled" @click="selectToConfirm(temp)">Select</button>
                    <button class="btn px-gd-2 ml-gd-1 fs-db-20 fw-400 btn-black btn-md btnUpgradePackage" v-else @click="upgradePackage()">
                      <img src="@assets/images/icon/crown.webp"/> 
                      {{ $t("engine.manageAppearance.theme.template.lblModalBuyPackage", languageEngine) }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
        </div>
        <div class="d-flex justify-content-center align-items-center pt-gd-1 px-gd-4 p-gd-1" style="height: 60px;">
          <div
            class="pageNav d-flex align-items-center justify-content-center"
            v-if="totalCount"
          >
            <b-pagination
              class="mr-30 mb-0"
              v-model="options.p"
              :per-page="options.take"
              :total-rows="totalCount"
              first-number
              last-number
              hide-goto-end-buttons
              hide-ellipsis
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-modal>
    <SelectTemplatePreview
      :templateData="preview"
      @selectTemplate="selectToConfirm"
    />
    <SelectTemplateConfirm @confirmed="confirmTemplate" />

    <ModalConfirmUpgrade 
      :modalID="'modal-confirm-upgrade-limit-page-on-change-template'"
      :title="$t('engine.common.dialogAlertLimit.lblTitlePageLimit',languageEngine)"
      :message="$t('engine.common.dialogAlertLimit.lblDescPageLimit',languageEngine)"
    />
  </fragment>
</template>

<script>
import SelectTemplatePreview from "@components_system/Design/Modal/SelectTemplatePreview/SelectTemplatePreview";
import SelectTemplateConfirm from "./SelectTemplateConfirm";
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import templateService from "@services/templateService.js";
import { debounce } from "lodash";
import ModalConfirmUpgrade from "@components_system/Design/Modal/ModalConfirmUpgrade/ModalConfirmUpgrade.vue";

export default {
  data() {
    return {
      fetching: false,
      templateList: [],
      displayCategory: {},
      categoryFilter: 0,
      menuSelected: 0,
      preview: {},
      options : {
        p: 1,
        take: 6,
        category : '0',
        text : ''
      },
      totalCount: 0,
      templateCategories: {},
      templateSelect: "",
    };
  },
  components :{
    TitleModal,
    SelectTemplatePreview,
    SelectTemplateConfirm,
    ModalConfirmUpgrade,
  },
  computed: {
    ...mapGetters({
      appearance: "design/metadata/appearance",
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      permissions: "design/permissionWebsite/permissions",
      siteComponents: "design/metadata/siteComponents",
    }),
    template() {
      return this.appearance && this.appearance.template;
    },
    numItemUsed() {
      return this.options.p !== 1 ? this.options.take : this.options.take - 1;
    },
    pageLimitNumber() {
      return this.permissions.PageNumber;
    },
    pageNumber() {
      const temp = JSON.parse(JSON.stringify(this.siteComponents));
      return Object.keys(temp).filter(item => temp[item].type == 'PAGE' && temp[item].properties.type == 'section').length || 0;
    },
  },
  mounted () {
    // this.init();
  },
  methods: {
    init() {
      this.preview = {};
      this.options = {
        p: 1,
        take: 6,
        category : '0',
        text : ''
      };
      
      this.categoryFilter = 0;
      this.menuSelected = 0;
      this.getTemplateCategories();
      this.getTemplateList();
    },
    reset() {
      this.option = {
        p: 1,
        take: 6,
        category : '0',
        text : ''
      };
    },
    close() {
      this.$bvModal.hide(`modal-select-template-website`);
      this.$bvModal.hide("modal-select-template-confirm");
      this.$bvModal.hide("modal-select-template-preview");
    },
    changeTake(options = {}) {
      if(options.take) {
        this.options.take = options.take;
        this.options.p = options.p;
      }
    },
    getTemplateList: debounce (
      async function() {
      let response = await templateService.getTemplateList({
        categoryID: this.categoryFilter,
        numItem: this.numItemUsed,
        page: this.options.p,
        templateID: this.template ? this.template.templateID : 0,
      });
      this.templateList = response.templateList;
      this.totalCount = response.totalCount;
      this.fetching = false;
    }, 1000),
    async getTemplateCategories() {
      let response = await templateService.getTemplateCategories({
        languageUse: this.languageUse
      });
      this.displayCategory = response.websiteCateTemplate
    },
    menuActive(menuId) {
      this.menuSelected = menuId;
    },
    selectCategory(categoryId) {
      this.fetching = true;
      this.categoryFilter = categoryId;
      this.getTemplateList();
    },
    openPreview(template) {
      this.preview = template;
      this.$bvModal.hide("modal-select-template-website");
      this.$bvModal.show("modal-select-template-preview");
    },
    selectToConfirm(template) {
      if(this.pageNumber >= this.pageLimitNumber) {
        this.$bvModal.show("modal-confirm-upgrade-limit-page-on-change-template");
      }else {
        this.templateSelect = template
        this.$bvModal.show("modal-select-template-confirm")
      }
    },
    async confirmTemplate() {
      this.close();
      if (process.env.VUE_APP_ENV_NAME == 'localApi' || process.env.VUE_APP_ENV_NAME == 'localDev') return;
      this.$store.dispatch('design/blockloading', {});

      let response = await templateService.postTemplateSelect({
        templateId: this.templateSelect.templateID,
        folderS3Template: this.templateSelect.templateDetail,
        languageUse: this.languageUse
      })
      if (response) {
        await this.setPage(response.mainPageID)
      } else {
        this.$store.dispatch("design/unblockloading", {})
      }
    },
    async setPage(id) {
      await this.$store.dispatch('design/snapshot/synceSnapshot', {});
      this.$store.dispatch("design/unblockloading", {})
      this.$store.dispatch("design/component/elActive", {});
      if (id) {
        this.$router.push("/#/page/" + id);
        location.reload();
      } else {
        this.$router.push("/");
        location.reload();
      }
    },
    upgradePackage() {
      this.$bvModal.show('modal-confirm-upgrade-insert');
    }
  },
  watch: {
    "options.p": {
      handler() {
        this.fetching = true;
        this.getTemplateList();
      }
    }
  },
  props : {

  }
}
</script>

<style lang="scss">
.modal-select-template-website {
  .modal-content {
    height: 100%;
    border: 1px solid #DEE3E6;
  }
  .modal-body {
    padding: 0;
    height: calc(95vh - 130px);
  }
  .wrapper { 
    display: flex;
    flex-flow: column;
    height: 100%;
    padding: 0px 24px;
    .template-categories {
      display: flex;
      height: 36px;
      justify-content: center;
      margin-top: 24px;
      .cate-wrapper {
        padding: 4px 16px;
        text-align: center;
        &.selected, &:hover {
          color: #28BEE3;
          border-bottom: 2px solid #28BEE3;
        }
      }
    }
    .cate-collapse-wrapper {
      list-style: none;
      display: table;
      background-color: #ffffff;
      padding-bottom: 15px;
      .cate-collapse {
        float: left;
        text-align: center;
        cursor: pointer;
        padding: 10px 15px;
        color: #373e44;
        font-size: 16px;
        background-color: #ffffff;
        &.selected, &:hover {
          color: #28BEE3;
        }
      }
    }
    #overlay-background {
      height: 100%;
    }
    .list {
      display: grid;
      height: 100%;
      grid-template-columns: repeat(3, calc(33.3333% - 32px));
      grid-gap: 32px;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #aaa #aaa;
      .thumbnail-wrapper {
        &.selected {
          .template-img-wrapper {
            position: relative;
            .selected-icon {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              z-index: 1;
              img {
                position: absolute;
                left: 50%;
                top: 50%;
                -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
              }
            }
            > img {
              filter: brightness(70%);
            }
            &::before {
              content: "";
              width: 100%;
              height: 100%;
              position: absolute;
            }
          }
        }
      }
    }
    .pageNav {
      .pagination {
        li {
          a,
          span {
            font-size: 16px;
          }
        }
        .page-item {
          &.active {
            .page-link {
              background-color: var(--primary);
              border-color: var(--primary);
            }
          }
        }
      }
    }
  }
  .wrapper-system{
    overflow-y: scroll;
    overflow-x: hidden;
     background-color: #f8f9fa;
  }
  .btnUpgradePackage {
    img {
      margin-top: -4px;
      height: 16px;
    }
  }
}
</style>